import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/design";
import { contentSpacingStyles, titleSpacingStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";

export default {
    fontFamilyImportUrl: "",
    body: {
        size: TYPOGRAPHY.size.base,
        weight: TYPOGRAPHY.weight.base,
        fontFamily: TYPOGRAPHY.fontFamily.base,
        lineHeight: TYPOGRAPHY.lineHeight.base,
    },
    legend: {
        size: TYPOGRAPHY.size.smallest,
        weight: TYPOGRAPHY.weight.base,
        color: "text",
        transform: "none",
        css: polyfillCss`
            letter-spacing: ${TYPOGRAPHY.letterSpacing.large};
            line-height : ${TYPOGRAPHY.lineHeight.small};
        `,
    },
    caption: {
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.base,
        color: "text",
        transform: "uppercase",
        css: polyfillCss`
            letter-spacing: ${TYPOGRAPHY.letterSpacing.larger};
            line-height : ${TYPOGRAPHY.lineHeight.small};
        `,
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: polyfillCss`
            ${contentSpacingStyles()}
        `,
    },
    h1: {
        size: 30,
        weight: TYPOGRAPHY.weight.light,
        lineHeight: 1.1,
        transform: "uppercase",
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 31, 37, null, 50], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h2: {
        size: 26,
        weight: TYPOGRAPHY.weight.light,
        lineHeight: 1.15,
        transform: "uppercase",
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 31, null, 45], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h3: {
        size: 23,
        weight: TYPOGRAPHY.weight.light,
        lineHeight: 1.15,
        transform: "uppercase",
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 24, null, 25], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h4: {
        size: 18,
        weight: TYPOGRAPHY.weight.base,
        lineHeight: 1.2,
        transform: "uppercase",
        css: polyfillCss`
        	${contentSpacingStyles("1.25em", "0.5em")}
        `,
    },
    h5: {
        size: 16,
        weight: TYPOGRAPHY.weight.base,
        lineHeight: 1.4,
        transform: "uppercase",
        css: polyfillCss`
        	${contentSpacingStyles("1.25em", "0.5em")}
        `,
    },
    h6: {
        size: 14,
        weight: TYPOGRAPHY.weight.base,
        lineHeight: 1.4,
        transform: "uppercase",
        css: polyfillCss`
        	${contentSpacingStyles("1.25em", "0.5em")}
        `,
    },
};
